<template>
  <header id="main" class="component app-header">
    <nav :class="{ active: navActive }">
      <div class="navbar">
        <span class="navbar-toggle" @click="toggleNavbar"></span>
        <router-link v-if="menuOptions.activity" :to="{name: 'category-activity'}">{{ $t('home.tabs.activity') }}</router-link>
        <router-link v-if="menuOptions.p2p" :to="{name: 'p2p'}">{{ $t('home.tabs.transportation') }}</router-link>
        <router-link v-if="menuOptions.packages" :to="{name: 'category-package'}">{{ $t('home.tabs.package') }}</router-link>
        <router-link v-if="menuOptions.products" :to="{name: 'category-product'}">{{ $t('home.tabs.product') }}</router-link>
        <router-link v-if="menuOptions.giftCert" :to="{name: 'giftcert'}">{{ $t('home.tabs.giftcert') }}</router-link>
      </div>

      <ul class="main-menu" :class="{ active: menuActive }">
        <li class="agent" v-if="loggedInAgent"><router-link :to="{name: 'agent'}">{{ loggedInAgent.firstName }}</router-link></li>
        <li>
          <a class="menu-toggle" @click="toggleMenu"></a>
          <ul class="sub-menu">
            <li><a @click="activateLanguage">{{ $t('menu.change-language') }}</a></li>
            <li v-if="currencyPickerActive"><a @click="activateCurrency">{{ $t('menu.change-currency') }}</a></li>
            <!-- <li><router-link :to="{name: 'find-mybooking'}">{{ $t('menu.my-bookings') }}</router-link></li> -->
            <li><router-link :to="{name: loggedInAgent ? 'agent': 'agent-login'}">{{ $t(loggedInAgent ? 'menu.agent-home' : 'menu.agent-login') }}</router-link></li>
          </ul>
        </li>
        <!-- TODO Jamie: Hide this cart button if it's on [cart],[checkout],[confirmation] page -->
        <li @mouseover="checkoutShow" @mouseout="checkoutShow">
          <router-link class="menu-cart" :to="{name: 'cart'}"><span class="cart-count" v-if="$cart.active.count">{{ $cart.active.count }}</span></router-link>
        </li>
      </ul>
    </nav>
    <!-- If it has items in the cart, show the total price and checkout button -->
    <!-- TODO Jamie: Hide this checkout button if it's on [cart],[checkout],[confirmation] page -->
    <router-link :to="{name: 'checkout'}" class="checkout" v-if="$cart.active.count" :class="{ 'cart-hover': cartHover }">
      <div>{{$t('cart.cart-total')}}: {{ $formatter.currency($cart.active.subTotal) }} ({{$cart.active.count}} {{$tc('cart.item', $cart.active.count)}})</div>
      <div class="checkout-button">Checkout</div>
    </router-link>
    <language-picker ref="languagePicker"/>
    <currency-picker ref="currencyPicker"/>
  </header>
</template>

<script>
import PortalSettings from '@/models/PortalSettings';
import Agent from '@/models/Agent';
import LanguagePicker from '@/components/LanguagePicker.vue';
import CurrencyPicker from '@/components/CurrencyPicker.vue';
import BodyClasses from '@/include/bodyClasses';

export default {
  data() {
    return {
      navActive: false,
      menuActive: false,
      cartHover: false,
      currencyPickerActive: PortalSettings.get('currency').choices.length > 1,
      p2pLabel: PortalSettings.get('p2pLabel', 'Shuttles'),
      menuOptions: PortalSettings.get('menuOptions') ? PortalSettings.get('menuOptions') : {}
    };
  },

  created() {
    if(this.$route.query.agentId && this.$route.query.agentId !== ''){
      Agent.addAffiliate(this.$route.query.agentId).then(() => {
        Agent.load();
      }).catch(err =>
        console.log(err)
      );
    }

    this.$router.afterEach((to, from) => {
      this.navActive = false;
      this.menuActive = false;
    });

    window.addEventListener('scroll', this.handleScroll);
  },

  computed: {
    loggedInAgent() {
      let result = false;
      let agent = Agent.active();

      if(agent && !agent.autoLogin) {
        result = agent;
      }

      return result;
    },

    enableGiftCert() {
      return PortalSettings.get('enableGiftCert', false);
    }
  },

  methods: {
    toggleNavbar() {
      this.navActive = !this.navActive;
    },

    toggleMenu() {
      this.menuActive = !this.menuActive;
    },

    activateLanguage() {
      this.menuActive = false;
      this.$refs.languagePicker.activate();
    },

    activateCurrency() {
      this.menuActive = false;
      this.$refs.currencyPicker.activate();
    },

    checkoutShow: function(){
      this.cartHover = !this.cartHover;
    },

    // Add shadow to header on scroll
    handleScroll() {
      let header = document.querySelector(".app-header");
      if (window.scrollY > 25 && !header.className.includes('sticked')) {
        header.classList.add('sticked');
      } else if (window.scrollY < 25) {
        header.classList.remove('sticked');
      }
    }
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  components: {
    LanguagePicker,
    CurrencyPicker
  }

}
</script>

<style lang="scss">
.app-header {

  @include full-width;
  position: sticky;
  top: 0;
  background-color: #fff;
  border-bottom: 1px solid $colorPaleGray;
  z-index: 2;

  &.sticked::after {
    content: "";
    display: block;
    margin-left: -15px;
    padding: 0 15px;
    width: calc(100% + 15px);
    position: absolute;
    left: 0;
    bottom: -12px;
    height: 12px;
    background: linear-gradient(to bottom, rgba(0,0,0,0.16) 0%, rgba(0,0,0,0.1) 20%, rgba(0,0,0,0) 100%);

    @include breakpoint(medium) {
      margin-left: 0;
      padding: 0;
      width: 100%;
    }
  }

  nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 0;
    @include breakpoint(medium) {
      justify-content: space-between;
    }

    ul {
      @include unlisted;
    }

    .navbar {
      background-color: $colorBgDarkGray;
      position: fixed;
      height: 100%;
      width: 280px;
      left: -280px;
      top: 0;
      padding: 45px 0;
      z-index: 1;
      transition: left .2s;
      @include breakpoint(medium) {
        background-color: #fff;
        position: relative;
        width: auto;
        display: flex;
        padding: 0;
        left: 0;
      }

      .navbar-toggle {
        @include font-awesome($fa-var-bars, light);
        $size: 45px;
        width: $size;
        height: $size;
        line-height: $size !important;
        text-align: center;
        font-size: 22px;
        color: $colorDarkGray;
        position: absolute;
        right: -53px;
        top: 0;
        @include breakpoint(medium) {
          display: none;
        }
      }

      a {
        display: block;
        width: 100%;
        color: #fff;
        text-align: center;
        padding: 15px 15px;
        font-size: 16px;
        line-height: 16px;

        @include breakpoint(medium) {
          width: auto;
          color: $colorDarkGray;
          font-size: 15px;
          height: 50px;
          display: flex;
          align-items: center;
          padding: 0 18px;
          transition: all .1s;

          &:hover {
            color: $colorDefault;
            background-color: $colorBgGray;
          }
        }

        &.router-link-active {
          opacity: .5;
          cursor: default;
          @include breakpoint(medium) {
            opacity: 1;
            color: $colorDefault;
            background-color: $colorBgGray;
          }
        }
      }
    }

    .main-menu {
      white-space: nowrap;
      display: flex;
      align-items: center;

      .agent {
        a {
          color: $colorDarkGray;
          display: inline-flex;
          align-items: center;
          height: 45px;
          &:hover {
            color: $colorDefault;
          }

          @include breakpoint(medium) {
            height: 50px;
            padding: 0 5px;
          }

          &::before {
            @include font-awesome-pseudo($fa-var-user-circle, light);
            margin-right: 4px;
            font-size: 22px;

            @include breakpoint(medium) {
              font-size: 24px;
            }
          }
        }
      }

      .menu-toggle {
        @include font-awesome($fa-var-ellipsis-v, solid);
        $size: 45px;
        width: $size;
        height: $size;
        line-height: $size;
        border-radius: $size / 2;
        font-size: 18px;
        text-align: center;
        color: $colorDarkGray;
        transition: all .1s;
        @include breakpoint(medium) {
          font-size: 20px;
        }

        &:hover {
          color: $colorDefault;
          background-color: $colorBgGray;
        }
      }

      >li {
        display: inline-block;
        position: relative;

        .sub-menu {
          display: none;
        }
      }

      &.active {
        >li {
          .menu-toggle {
            color: $colorDefault;
            background-color: darken( $colorBgGray, 5% )
          }
          .sub-menu {
            display: block;
            position: absolute;
            box-shadow: 0 2px 4px 1px rgba(0,0,0,.3);
            border-radius: 4px;
            top: 45px;
            right: 0;
            z-index: 999;
            background-color: #fff;
            padding: 10px 0;

            a {
              padding: 6px 20px;
              display: block;
              color: $colorDefault;

              &:hover {
                background-color: $colorPaleBlueGray;
              }
            }
          }
        }
      }

      .menu-cart {
        @include font-awesome($fa-var-shopping-cart, light);
        $size: 45px;
        width: $size;
        height: $size;
        line-height: $size;
        border-radius: $size / 2;
        font-size: 20px;
        text-align: center;
        color: $colorDarkGray;
        position: relative;
        transition: all .1s;
        @include breakpoint(medium) {
          font-size: 22px;
        }
        &:hover {
          color: $colorDefault;
          background-color: $colorBgGray;
        }
      }

      .cart-count {
        font-family: $fontFamilyDefault;
        $size: 20px;
        width: $size;
        height: $size;
        line-height: $size;
        border-radius: $size / 2;
        background-color: $colorCTA;
        color: #fff;
        display: inline-block;
        font-size: 12px;
        text-align: center;
        position: absolute;
        top: 3px;
        right: 0px;
      }
    }

    // Overlay for mobile nav
    &::before {
      content: "";
      background-color: rgba(0,0,0,0);
      transition: background-color .2s;
      @include breakpoint(medium) {
        content: none;
      }
    }

    &.active {
      // Overlay for mobile nav
      &::before {
        content: "";
        background-color: rgba(0,0,0,.5);
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
      }

      .navbar {
        left: 0;
        box-shadow: 0 10px 30px rgba(0, 0, 0, .3);
        z-index: 999;

        .navbar-toggle {
          @include font-awesome($fa-var-times, light);
          background-color: $colorBgDarkGray;
          color: #fff;
          right: 10px;
        }
      }
    }
  }

  // Checkout tooltip
  .checkout {
    $transition: all .5s ease .6s;
    $transition2: all .1s ease 1.1s;

    @include full-width;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: $colorDarkGray;
    color: #fff;
    font-size: 13px;
    position: relative;
    top: 0;
    height: 38px;
    transition: $transition;

    @include breakpoint(medium) {
      background-color: $colorBlue;
      position: absolute;
      margin: 0 30px 0 0;
      padding: 0 15px;
      width: auto;
      top: 30px;
      right: 0;
      height: 0;
      opacity: 0;
      z-index: 1;
      border-radius: 5px;
    }

    /*  IE */
    @media all and (-ms-high-contrast:none) {
      margin: 0;
    }

    &::before {
      content: "";
      display: block;
      width: 12px;
      height: 12px;
      background-color: $colorDarkGray;
      position: absolute;
      top: 0px;
      right: 32px;
      transform: rotate(45deg);
      transform-origin: right;
      transition: $transition;

      @include breakpoint(medium) {
        background-color: $colorBlue;
        width: 0;
        height: 0;
        right: 17px;
        transition: $transition2;
      }
    }

    &:hover {
      @include breakpoint(medium) {
        opacity: .8 !important;
      }
    }

    > div {
      @include breakpoint(medium) {
        font-size: 0;
        transition: $transition2;
      }
    }

    .checkout-button {
      text-transform: uppercase;
      margin: 0 0 0 15px;

      @include breakpoint(medium) {
        margin: 0;
      }

      &::after {
        @include font-awesome-pseudo($fa-var-chevron-right, light);
        margin-left: 6px;

        @include breakpoint(medium) {
          margin-left: 0;
          transition: $transition2;
        }
      }
    }

    // Mobile showing tooptip
    .cart-updated & {
      background-color: $colorBlue;
      transition: all .2s;

      &::before {
        background-color: $colorBlue;
        transition: all .2s;
      }
    }

    // Desktop showing tooptip
    @include breakpoint(medium) {
      .cart-updated & {
        @include header-checkout-tooltip-showing;
      }
      &:hover {
        @include header-checkout-tooltip-showing;
      }
      &.cart-hover {
        @include header-checkout-tooltip-showing;
      }
    }
  }
}
</style>